import { Component } from 'react';

import { configValue } from '#/config/appConfigUtils';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { recaptcha } from '#/utils/recaptcha';

import { StyledRecaptchaInput } from './RecaptchaInput.styled';

type RecaptchaInputProps = {
  locale: I18nLocale;
  onChange: (response?: string) => void;
  siteKey?: string | null;
};

export class RecaptchaInput extends Component<RecaptchaInputProps> {
  setupRecaptcha = (el: Element | null | undefined) => {
    const { locale } = this.props;

    if (!el) return;
    void recaptcha({ locale }).then((r) => {
      const { siteKey, onChange } = this.props;
      r.render(el, {
        sitekey: siteKey ?? configValue('google', 'recaptcha', 'siteKey'),
        callback: (response: string) => {
          onChange(response);
        },
        'expired-callback': () => {
          // Remove old value because it's no longer valid
          onChange();
        },
      });
    });
  };

  render() {
    return <StyledRecaptchaInput ref={this.setupRecaptcha} />;
  }
}
